import { render, staticRenderFns } from "./Intro4.vue?vue&type=template&id=546a09c2&scoped=true&"
import script from "./Intro4.vue?vue&type=script&lang=js&"
export * from "./Intro4.vue?vue&type=script&lang=js&"
import style0 from "./Intro4.vue?vue&type=style&index=0&id=546a09c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a09c2",
  null
  
)

export default component.exports